import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface AuditDisclosureSnapshotState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: AuditDisclosureSnapshotState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const auditDisclosureSnapshotSlice = createSlice({
    name: 'AuditDisclosureSnapshot',
    initialState,
    reducers: {
        setAuditDisclosureSnapshot: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setAuditDisclosureSnapshot, reset } = auditDisclosureSnapshotSlice.actions;
export const getAllAuditDisclosureSnapshotDetails = (state: RootState) => state.auditDisclosureSnapshot.data;
export const getAuditDisclosureSnapshotTotalRecords = (state: RootState) => state.auditDisclosureSnapshot.totalRecords;
export default auditDisclosureSnapshotSlice.reducer;
